'use strict';

function initHorizontalScrollArrows(options) {
	var selector = options && options.selector;
	if (!selector) return;

	var leftSrc = (options && options.leftSrc) || '{{ASSETS_DIR}}/images/left-arrow.png';
	var rightSrc = (options && options.rightSrc) || '{{ASSETS_DIR}}/images/right-arrow.png';
	var scrollByRatio = (options && options.scrollByRatio) || 0.9;

	function setupForElement(el) {
		if (!el || el.__promScrollArrowsAttached) return;
		el.__promScrollArrowsAttached = true;

		var parent = el.parentElement;
		if (!parent) return;
		if (getComputedStyle(parent).position === 'static') {
			parent.style.position = 'relative';
		}

		var leftBtn = document.createElement('button');
		leftBtn.type = 'button';
		leftBtn.className = 'prom-scroll-arrow prom-scroll-arrow--left';
		leftBtn.setAttribute('aria-label', 'Scroll left');
		leftBtn.innerHTML = '<img alt="" src="' + leftSrc + '">';

		var rightBtn = document.createElement('button');
		rightBtn.type = 'button';
		rightBtn.className = 'prom-scroll-arrow prom-scroll-arrow--right';
		rightBtn.setAttribute('aria-label', 'Scroll right');
		rightBtn.innerHTML = '<img alt="" src="' + rightSrc + '">';

		function update() {
			var maxScrollLeft = el.scrollWidth - el.clientWidth;
			if (maxScrollLeft <= 1) {
				leftBtn.style.display = 'none';
				rightBtn.style.display = 'none';
				return;
			}

			var epsilon = 2;
			var atStart = el.scrollLeft <= epsilon;
			var atEnd = el.scrollLeft >= (maxScrollLeft - epsilon);

			leftBtn.style.display = atStart ? 'none' : '';
			rightBtn.style.display = atEnd ? 'none' : '';
		}

		leftBtn.addEventListener('click', function () {
			el.scrollBy({ left: -Math.max(1, el.clientWidth * scrollByRatio), behavior: 'smooth' });
		});
		rightBtn.addEventListener('click', function () {
			el.scrollBy({ left: Math.max(1, el.clientWidth * scrollByRatio), behavior: 'smooth' });
		});

		el.addEventListener('scroll', update, { passive: true });
		window.addEventListener('resize', update);

		// Some grids render async; update after children change.
		var mo = new MutationObserver(function () {
			requestAnimationFrame(update);
		});
		mo.observe(el, { childList: true, subtree: false });

		parent.appendChild(leftBtn);
		parent.appendChild(rightBtn);

		update();
	}

	function setupAll() {
		var els = document.querySelectorAll(selector);
		if (!els || !els.length) return;
		els.forEach(function (el) {
			setupForElement(el);
		});
	}

	// If elements exist now, set up all of them.
	setupAll();

	// If they get replaced later (Vue), watch for them and rescan (throttled).
	var root = document.body;
	var pending = false;
	function scheduleScan() {
		if (pending) return;
		pending = true;
		requestAnimationFrame(function () {
			pending = false;
			setupAll();
		});
	}

	var observer = new MutationObserver(function () {
		scheduleScan();
	});
	observer.observe(root, { childList: true, subtree: true });

	return observer;
}

module.exports = {
	initHorizontalScrollArrows: initHorizontalScrollArrows
};
